(function ($) {
    // Forms with remotely validated fields may not be submitted on the first try
    // if any of the remote fields held a pre-filled value and were not touched by the user.
    // Running the request synchroniously fixes this.
    $(document).ajaxSend(function (event, jqxhr, settings) {
        var target = $(event.target);
        if (target.is('form') && target.find('[data-val-remote]').length > 0) {
            settings.async = false;
        }
    });
})(jQuery);